import React from "react";

export default function Loader() {
  return <span className="spinner-border spinner-border-sm ml-2"></span>;
}
